<!-- =========================================================================================
  File Name: BoardAddTabInformation.vue
  Description: Board Add Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div>
    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col w-full">
        <form @submit.prevent>
            <vs-input name="title" label-placeholder="제목" v-model="title" v-validate="'required'" class="w-full mb-6" />
            <vs-input name="writerName" label-placeholder="작성자" v-model="writerName" v-validate="'required'" class="w-full mb-6" />
            <div class="email-compose">
              <editor-tiptap :description="''" :menubar="true" :readOnly="false" @editorContent="content"></editor-tiptap>
            </div>

            <!-- File -->
            <vs-upload 
            ref="uploadFileInput"
            @change="updateCurrFile"
            multiple 
            text="첨부파일" 
            :show-upload-button="false" 
            class="compose-mail-attachment" />
        </form>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSave" :disabled="!validateForm">저장</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { postData } from '@/api/module'


export default {
  components: {
  },
  data () {
    return {
      title : '',
      writerID : '',
      writerName : '',
      writerEmail : '',
      clientIP : '',
      inputFilesxList: [],
      boardAttachList : [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30
      }
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.title && this.writerName && this.content
    },
    getUserInfo () {
      return this.$store.getters.getUserInfo
    }
  },
  methods: {
    content (value) {
      this.content = value
    },
    confirmSave () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '게시글 추가',
        text: '저장 하시겠습니까?',
        accept: this.save,
        acceptText: '저장'
      })
    },
    updateCurrFile () {
      // console.log(this.$refs.uploadFileInput.filesx)
      this.inputFilesxList = this.$refs.uploadFileInput.filesx
      // console.log(this.inputFilesxList)
    },
    async uploadFile (file) { // 파일업로드
      try {
        const formData = new FormData()

        formData.append('file', file)

        // for (const key of formData.entries()) {
        //   console.log(`${key}`)
        // }

        const {data} = await postData('uploadFile', formData, { 
          headers : { 
            'Content-Type': 'multipart/form-data'
          }
        })
        // console.log(data)

        const newObject = {
          realName : data.data.realName,
          fileName : data.data.fileName,
          contentType : data.data.contentType,
          size : data.data.size
        }
        this.boardAttachList.push(newObject)

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async save () {
      if (!this.validateForm) return
      try {
        // for (let i = 0; i < this.inputFilesxList.length; i++) {
        for (const file of this.inputFilesxList) {
          // const file = this.inputFilesxList[index]
        
          const removeFlag = file.remove
          if (!removeFlag) {
            await this.uploadFile(file)
          }

        }

        await postData('board', {
          
          boardSeq : 1,
          title : this.title,
          writerID : this.getUserInfo.userID,
          writerName : this.writerName,
          writerEmail : this.getUserInfo.eMail,
          content : this.content,
          // clientIP : this.clientIP

          boardAttachList : this.boardAttachList

        })

        this.$router.push('/board/board-list')
        this.showSaveSuccess()

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '게시글 추가',
        text: '저장 되었습니다.'
      })
    }
  }
}
</script>
<style>
.editor__content { 
  overflow: auto !important;
  border-right: 1px solid #ccc !important;
  border-bottom: 1px solid #ccc !important;
  border-left: 1px solid #ccc !important;
  height: 450px !important;
}
.con-img-upload .con-input-upload{
  height: 2.5rem;
  width: 100%;
  margin: 0;
}

.con-img-upload .img-upload {
  margin: 0;
  margin-bottom: .5rem;
  margin-right: 1.5rem;
}
</style>